import { render, staticRenderFns } from "./UserTags.vue?vue&type=template&id=2ac4f4cc"
import script from "./UserTags.vue?vue&type=script&lang=js"
export * from "./UserTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports